import { render, staticRenderFns } from "./PossibleAnswers.vue?vue&type=template&id=4469b583&scoped=true"
import script from "./PossibleAnswers.vue?vue&type=script&lang=js"
export * from "./PossibleAnswers.vue?vue&type=script&lang=js"
import style0 from "./PossibleAnswers.vue?vue&type=style&index=0&id=4469b583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4469b583",
  null
  
)

export default component.exports